import * as React from "react";
import vingleHref from "@vingle/wtf-sdk/helpers/vingleHref";
import { VingleURL } from "@vingle/wtf-sdk/url";
import PageUpdater from "@vingle/wtf-sdk/components/pageUpdater";

function TrendingContainerHelmet({
  section,
  selectedSectionId,
  selectedSectionContents,
}: {
  section?: Vingle.Discover.ITrendingSection;
  selectedSectionId: string | null;
  selectedSectionContents: Vingle.IPaginatedList<
    Vingle.Discover.IDiscoverContent
  > | null;
}) {
  if (!section || !selectedSectionContents || !selectedSectionId) {
    return null;
  }
  const links = [];
  if (selectedSectionContents.paging.after) {
    links.push({
      rel: "next",
      href: vingleHref(
        new VingleURL.DiscoverTrendingSection({
          sectionId: selectedSectionId,
        }),
        { after: selectedSectionContents.paging.after as string },
      ),
    });
  }
  const metaObjects = [{ property: "website", content: "website" }];
  return (
    <PageUpdater metaObjects={metaObjects} link={links} title={section.title} />
  );
}

export default React.memo(TrendingContainerHelmet);
